<template>
  <div>
    <el-date-picker v-model="dd"
                    :disabled="disabled"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    size="small">
    </el-date-picker>
  </div>
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeDate",
  mixins: [LibProductItem],
  props: {
    value: String
  },
}
</script>
